export const exerciseOptions = {
  method: 'GET',
  headers: {
    'X-RapidAPI-Key': '6987025984mshf2859aedcff7fa0p190f74jsn9d59463753b0',
    'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com',
  },
};

export const youtubeOptions = {
  method: 'GET',
  headers: {
    'X-RapidAPI-Key': '6987025984mshf2859aedcff7fa0p190f74jsn9d59463753b0',
    'X-RapidAPI-Host': 'youtube-search-and-download.p.rapidapi.com',
  },
};

export const fetchData = async (url, options) => {
  const res = await fetch(url, options);
  const data = await res.json();

  return data;
};
